import React, { useEffect, useContext } from 'react';
import { gql, useQuery } from '@apollo/client';
import LocationContext, { SiteSettingsProps } from './Context';
import { useWindowSize } from '../hooks';

const GET_SETTINGS = gql`
    query SiteSettings {
        siteSettings {
            siteConfig {
                stockistsMessage
                showStockistsMessage
                stockistRange
            }
        }
    }
`;

const SiteSettings = ({ children }) => {
    // Get the base settings of the app
    const { loading, error, data } = useQuery(GET_SETTINGS);

    const { siteSettings, setSiteSettings, setAppHeight, appHeight } = useContext(LocationContext);
    const { height: windowHeight, width: windowWidth } = useWindowSize();

    useEffect(() => {
        if (!siteSettings && !loading && !error && data) {
            const settings: SiteSettingsProps = {
                stockistsMessage: data?.siteSettings?.siteConfig?.stockistsMessage,
                showStockistsMessage: data?.siteSettings?.siteConfig?.showStockistsMessage,
                stockistRange: data?.siteSettings?.siteConfig?.stockistRange,
            };
            setSiteSettings?.(settings);
        }
    }, [loading, error, data, siteSettings, setSiteSettings]);
    useEffect(() => {
        if (windowHeight) {
            const headerElm = document.querySelector('.header') as HTMLElement;
            const containerHeight = (headerElm  && windowWidth && windowWidth >= 768 ) ? windowHeight - headerElm.offsetHeight : windowHeight;
            setAppHeight?.(containerHeight);
        }
    }, [setAppHeight, windowHeight, windowWidth]);

    return (
        <>
            <div className="stockist-app" style={{ minHeight: appHeight }}>
                {children}
            </div>
        </>
    );
};

export default SiteSettings;
